function debounce(func){
    let timer;
    return function(e){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func,100,e);
    }
}

window.addEventListener('resize',debounce(function(e){
    const productsSliders = window.document.querySelectorAll('.js_product-slider');
    const customSliders = window.document.querySelectorAll('.js_custom-slider');
    if (productsSliders.length > 0){
        productsSliders.forEach(productSlider =>{
            const productSliderFlickity = Flickity.data(productSlider)
            if(productSliderFlickity) productSliderFlickity.resize();
        })
    }
    if (customSliders.length > 0){
        customSliders.forEach(customSlider =>{
            const customSliderFlickity = Flickity.data(customSlider);
            if(customSliderFlickity) customSliderFlickity.resize();
        })
    }
}))